module.exports = " <div class=row> <div class=col-md-12> <table class=\"table table-condensed table-stripped table-bordered\"> <thead> <tr> <th>Nombre</th> <th>Slug</th> <th>Class</th> <th>Acciones</th> </tr> </thead> <tbody> <tr v-for=\"award in awards\"> <td>{{ award.name }}</td> <td>{{ award.slug }}</td> <td>{{ award.class }}</td> <td></td> </tr> </tbody> </table> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/AwardsList.vue
 ** module id = 301
 ** module chunks = 1
 **/